import React from 'react'
import intl from 'react-intl-universal'
import { getPackageDiscountPercent } from '../../utils/price'
import './index.less'

/**
 * 权益套餐折扣角标：产品图片右上角展示「优惠xx%」
 */
const PackageDiscountBadge = ({ product }) => {
  const percent = getPackageDiscountPercent(product)
  if (!percent) return null

  return (
    <div className="package-discount-badge">
      {intl.get('package_off_percent', { num: percent }).d(`优惠${percent}%`)}
    </div>
  )
}

export default React.memo(PackageDiscountBadge)
